import { LIFECYCLE_TAGS, LIFECYCLE_TAG_DESCRIPTIONS } from "./constants";

export const describeTransactionType = (transactionType) => {
  const t = transactionType.toLowerCase();
  if (t === "buying") {
    return "purchase";
  } else if (t === "selling") {
    return "sale";
  }
  if (t === "remortgaging") {
    return "remortgage";
  } else if (t === "probate") {
    return "probate case";
  } else {
    return t;
  }
};

export const getFormattedDate = (date) => {
  let dateToFormat = new Date(date);

  const datePart = `${dateToFormat.toLocaleDateString("en-GB", { month: "short", day: "numeric" })}`;
  const formattedDate = `${datePart}`;

  return formattedDate;
};

// Convert datetime objects to string in the format 15 February 2024
export const formatDate = (datetime) => {
  const date = new Date(datetime);
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-GB", options);
};

// Convert a datetime object to a string in the format 15/02/2024, 12:34
export const formatDateTime = (datetime) => {
  return new Date(datetime).toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" });
};

export const getTagGroupName = (tag) => {
  return LIFECYCLE_TAGS[tag]?.name || null;
};

export const getFormattedLifecycleTag = (activeTag, memoReceivedDate) => {
  if (!activeTag) {
    return null;
  }

  const tagObject = LIFECYCLE_TAG_DESCRIPTIONS.tags.find((t) => t.tag === activeTag);
  if (!tagObject) {
    return null;
  }

  // If we don't have a memorandum of sale the case is grouped in the Pre-MOS bucket, so show that.
  if (!memoReceivedDate) {
    return LIFECYCLE_TAGS["pre_memo"].name;
  }

  return tagObject ? tagObject.description : null;
};

export const joinNames = (names) => {
  if (!names) {
    return null;
  }
  // lastNames is an array of strings
  // e.g. ["Smith", "Jones"]
  if (names.length === 2) {
    return names.join(" and ");
  } else if (names.length > 2) {
    return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
  } else {
    return names[0] || "";
  }
};

// A mailto: href, or null when the field holds something other than one address ("TBC", a
// phone number). A stored address is not guaranteed clean, so "?", "&" and "#" are encoded:
// otherwise "client@example.com?bcc=x@evil.com" would add a recipient to the agent's email.
export const mailtoHref = (email) => {
  const address = email.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address) ? `mailto:${address.replace(/[?&#]/g, encodeURIComponent)}` : null;
};

// A tel: href for a number typed by hand, or null unless the field holds exactly one UK or
// international number. A leading label ("Tel:") and anything from the next letter on ("ext 12",
// "Option 1") are dropped, as are spacing, punctuation, invisible characters pasted from email
// signatures, and the trunk 0 after a 44 country code ("+44 (0)20", "+44 020").
export const telHref = (phone) => {
  const [number, ...rest] = phone.replace(/^[^\d+(]+/, "").split(/[a-z]/i);
  if (rest.join("").replace(/\D/g, "").length >= 7) {
    return null; // a second number, e.g. "T: 01234 567890 M: 07700 900123"
  }
  const digits = number
    .replace(/(\d\D*)\(0\)/, "$1")
    .replace(/[^\d+]/g, "")
    .replace(/(?!^)\+/g, "")
    .replace(/^00/, "+")
    .replace(/^(\+?44)0/, "$1")
    .replace(/^44(?=\d{9,10}$)/, "+44");
  return /^(0\d{9,10}|\+44\d{9,10}|\+(?!44)\d{7,14})$/.test(digits) ? `tel:${digits}` : null;
};
